import React  from 'react'
import { useTextResources } from '../../../language';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';

const IsAvailableForSaleDropDown = ({nullable, ...rest}) => {
    const text = useTextResources();
    const options = [
        {
            Name: text("IsAvailableForSale"),
            Value: true
        },
        {
            Name: text("IsUnavailableForSale"),
            Value: false
        },
        nullable ? {
            Name: " ",
            Value: null
        } : null
    ]

    return <DropDown data={options.filter(o => !!o)} textField="Name" valueField="Value"  {...rest}/>
}

IsAvailableForSaleDropDown.propTypes = {
    nullable: PropTypes.bool,
}

export default IsAvailableForSaleDropDown

